import React from 'react';
import { Modal, Card, CardContent, Portal, CardHeader, IconButton } from '@mui/material';
import { JsonForms } from '@jsonforms/react';
import {
  materialCells,
  materialRenderers
} from '@jsonforms/material-renderers';
import CloseIcon from '@mui/icons-material/Close';

import HorizontalResponsiveRenderer, { HorizontalResponsiveTester } from '../../../components/json-forms/layouts/HorizontalResponsive';
import TextRenderer, { TextTester } from '../../../components/json-forms/layouts/Text';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};


export default function SurveyPreview ({ handleClose, data, jsonSchema, schemaUI }) {
  const translator = (key, defaultMessage) => {

    if (key.endsWith('.required')) {
      return 'To pole jest wymagane';
    }

    if (key.endsWith('.pattern') || key.endsWith('.format')) {
      return 'Niepoprawna wartość pola';
    }

    return defaultMessage;
  };

  const renderers = [
    ...materialRenderers,
    { tester: HorizontalResponsiveTester, renderer: HorizontalResponsiveRenderer },
    { tester: TextTester, renderer: TextRenderer }
  ];

  return (
    <Portal >
      <Modal open={true} onClose={handleClose}>
        <Card style={{ width: '60vw', maxHeight: '80vh', ...style, display: 'flex', flexDirection: 'column' }}>
          <CardHeader title="Ankieta" action={<IconButton onClick={handleClose}><CloseIcon /></IconButton>}/>
          <CardContent style={{ overflow: 'auto', flex: 1 }}>
            <JsonForms
              i18n={{ locale: 'pl', translate: translator }}
              schema={jsonSchema}
              uischema={schemaUI}
              data={data}
              renderers={renderers}
              cells={materialCells}
              validationMode="ValidateAndHide"
              readonly
            />
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
};
